import { useController, useFormContext } from "react-hook-form";
import {
  useFieldProps,
  FieldBaseProps,
} from "@shared/features/form/useFieldProps";
import { Button } from "./Button";

export type Props = FieldBaseProps & {
  name: string;
  options: { label: string; value: number }[];
  id?: string;
};

export function YesNoButtons({
  name,
  required = false,
  error,
  isLoading,
  isSubmitting,
  options,
  className,
  id,
}: Props) {
  const form = useFormContext();

  const {
    field: { value, onChange, onBlur },
  } = useController({
    name,
    control: form.control,
    defaultValue: undefined,
    rules: {
      required: required ? "This field is required" : false,
    },
  });

  const fieldProps = useFieldProps({
    className,
    error,
    isLoading,
    isSubmitting,
    required,
  });

  return (
    <div
      {...fieldProps}
      className="border-none flex flex-row gap-2"
      onBlur={onBlur}
      aria-labelledby={`${id}-label`}
      role="radiogroup"
    >
      {options.map((option) => (
        <Button
          key={option.value}
          className="w-full"
          variant={
            value && value.length && option.value === value[0]
              ? "primary"
              : "secondary"
          }
          type="button"
          onClick={() => onChange([option.value])}
          data-testid={`yesno-buttons-${option.label.toLowerCase()}`}
          aria-label={option.label}
          aria-checked={value && value.length && option.value === value[0]}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}

export default YesNoButtons;
